<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202509_01.jpg" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>乾燥の正体は“夏疲れ”かも。</span><br>9月から始める秋枯れ肌リセット美容</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">夏疲れが忍び寄る秋の肌</h3>
        <p class="mb-3">強い紫外線、冷房の風、汗や皮脂による摩擦...夏を過ごした肌には、目に見えにくい疲れが蓄積しています。</p>
        <p class="mb-3">その「夏疲れ」は、9月になると“秋枯れ肌”として現れ、乾燥やくすみ、ハリ不足を引き起こします。</p>
        <p>秋の始まりは、肌を立て直し、冬へ備えるための重要なタイミングなのです。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">秋枯れ肌のメカニズム</h3>
        <p class="mb-3">秋になると急に肌の調子が悪くなると感じる方は少なくありません。</p>
        <p class="mb-3">それは単なる季節の乾燥ではなく、夏に受けた紫外線や冷房ダメージが遅れて表面化しているからです。</p>
        <p class="mb-3">肌のバリア機能が弱まり、水分保持力が低下すると、表面はかさつき、内側はごわつきやくすみが目立ちます。</p>
        <p>これが「秋枯れ肌」と呼ばれる現象であり、年齢や肌質を問わず誰にでも起こり得ます。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509_03.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">乾燥対策の新常識 “多層的なうるおい”</h3>
        <p class="mb-3">乾燥を防ぐために必要なのは、ただ保湿を重ねることではなく、肌の浅い部分から深い部分までうるおいを届ける“多層的な保湿”です。</p>
        <p class="mb-3">弱った肌に単純な保湿をしてもすぐに乾いてしまうのは、角層全体に水分が行き渡っていないことが考えられます。</p>
        <p>分子サイズや性質が異なる成分を組み合わせることで、肌を表面から奥深くまで支えることができます。</p>
      </div>
    </div>

    <div class="pt-5 mt-5 text-center">
      <h2 class="mb-3">4種のヒアルロン酸を贅沢に配合<br>マナビス化粧品の隠れた名品「リフトセラム」</h2>
      <p>そこで提案したいのが、肌の表面から角層の奥まで<br>しっかりとうるおいを届けることを可能にする“4種のヒアルロン酸”を配合したケアです。<br>特性の異なるヒアルロン酸をバランスよく組み合わせることで、<br>うるおいのレイヤーを重ねるように肌を守り、乾燥やハリ不足に多角的にアプローチできます。</p>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">リフトセラムに配合された4種のヒアルロン酸</h3>
        <p class="mb-3">マナビス化粧品の「リフトセラム」には、特性の異なる4種類のヒアルロン酸が贅沢に配合されています。</p>
        <ul>
          <li><strong>ヒアルロン酸Na：</strong>高分子で肌表面にうるおいの膜を作り、水分蒸発を防ぎます。</li>
          <li><strong>アセチルヒアルロン酸Na：</strong>角層に吸着して保湿力を高め、しっとり感を長時間キープします。</li>
          <li><strong>加水分解ヒアルロン酸：</strong>分子が小さく、角層の奥まで浸透して内側からふっくら感を支えます。</li>
          <li><strong>加水分解ヒアルロン酸アルキル（C12-13）グリセリル：</strong>親水性と疎水性を併せ持ち、バリア機能を補いながらうるおいを抱え込む働きがあります。</li>
        </ul>
        <p>これらの相乗効果により、表面から内側まで隅々にうるおいを届ける“レイヤー保湿”が可能になるのです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509_05.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">リセット美容を習慣に</h3>
        <p class="mb-3">「リフトセラム」は、夏のダメージを持ち越さず、秋枯れ肌を防ぐための心強いパートナーです。</p>
        <p class="mb-3">みずみずしくなじむテクスチャーは、乾燥小ジワやハリ不足に悩む肌にもやさしく寄り添い、使うたびにうるおいとハリを実感できます。</p>
        <p>毎日のケアに取り入れることで、肌の立て直しを“習慣”として定着させることができます。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202509_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3 text-center">9月が勝負、お肌の“リセット月間”</h3>
        <p class="mb-3">夏の疲れを放置すると、秋から冬にかけての乾燥は深刻化しやすくなります。だからこそ、9月を『肌を整えるリセット月間』として意識したいのです。</p>
        <p class="mb-3">乾燥の正体が“夏疲れ”にあることを理解し、多層的なうるおいで満たすケアを始めることが、美肌を守る近道です。</p>
        <p>リフトセラムの4種ヒアルロン酸によるレイヤー保湿を味方に、透明感とハリを兼ね備えた秋肌を手に入れてみませんか。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3">秋枯れ肌を防ぐなら....</p>
        <p class="mb-3 fs-2">マナビス化粧品「リフトセラム」</p>
        <p class="mb-3">「4種のヒアルロン酸を贅沢に配合」したリフトセラムは、<br>角層のすみずみまで多層的にうるおいを届ける美容液です。</p>
        <p class="mb-3">ヒアルロン酸Naが肌表面にうるおいの膜を作り、アセチルヒアルロン酸Naがしっとり感をキープ。</p>
        <p class="mb-3">加水分解ヒアルロン酸が角層奥に浸透し、アルキル化ヒアルロン酸がバリア機能を支えます。</p>
        <p>夏疲れをリセットし、乾燥や小ジワに負けない透明感とハリを育む一滴です。</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}
ul {
  list-style: disc;
  margin-left: 25px;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>